import React from "react";
import {Typography} from "@mui/material";
import {OptionalVarsDto} from "../../../../../../../dtos";

interface Props {
    variable: OptionalVarsDto;
}


export const OptionalVarString: React.FC<Props> = ({
                                                       variable
                                                   }) => {
    return (
        <>
            {
                variable.name !== '' &&
                <>
                    <Typography
                        variant={`body2`}
                        bgcolor={`success.light`}
                        display={`inline`}>
                        &
                    </Typography>
                    <Typography
                        variant={`body2`}
                        bgcolor={`#dbeaff`}
                        display={`inline`}
                    >
                        {variable.name}
                    </Typography>
                </>
            }
            {
                variable.name !== '' &&
                variable.value !== '' &&
                <>
                    <Typography
                        variant={`body2`}
                        bgcolor={`success.light`}
                        display={`inline`}>
                        =
                    </Typography>
                    <Typography
                        variant={`body2`}
                        bgcolor={`#dbeaff`}
                        display={`inline`}
                    >
                        {variable.value}
                    </Typography>
                </>
            }

        </>
    )
}